import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Application } from '../../models/applications/application.model';
import { ApiApplicationsService } from '../../services/applications/api/api-applications.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalsService } from '../../services/modals.service';
import { ApplicationAddModalComponent } from './modals/application-add-modal/application-add-modal.component';
import { ApplicationEditModalComponent } from './modals/application-edit-modal/application-edit-modal.component';

@Component({
  templateUrl: 'applications.component.html',
  standalone: true,
  imports: [CommonModule, TooltipModule, ApplicationAddModalComponent, ApplicationEditModalComponent]
})
export class ApplicationsComponent implements OnInit {

  @ViewChild('addModal') addModal!: ApplicationAddModalComponent;
  @ViewChild('editModal') editModal!: ApplicationEditModalComponent;

  applications: Application[] = [];

  constructor(
    private apiApplicationsService: ApiApplicationsService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  ngOnInit(): void {
    this.refreshApplications();
  }

  onClickAdd(): void {
    this.addModal.show(() => this.refreshApplications());
  }

  onClickEdit(application: Application): void {
    this.editModal.show(application.id, application.name, () => this.refreshApplications());
  }

  onClickDelete(application: Application): void {
    this.modalsService.showConfirmModal(() => {
      this.apiApplicationsService.deleteApplication(application.id).then(
        () => {
          this.alertsService.displayAlertSuccess('Application deleted !');
          this.refreshApplications();
        }, error => {
          this.alertsService.displayAlertError('Error deleting application : ' + error);
        }
      );
    });
  }

  private refreshApplications(): void {
    this.apiApplicationsService.getApplications().then(
      response => {
        this.applications = response.results;
      }, error => {
        this.alertsService.displayAlertError('Error loading applications : ' + error);
      }
    );
  }
}
